import isObject from 'lodash-es/isObject';
import zipObject from 'lodash-es/zipObject';
import { IWebStorage } from '@df/browser/storage/global-storage.service';

export abstract class AbstractStorageService implements IWebStorage {
    /**
     * Set value in storage
     */
    set(name: string, value: any, immediate = false): void {
        let data = this.getData();

        if (!isObject(data)) {
            data = {};
        }
        if (value === null) {
            if (data[name] !== undefined) {
                delete data[name];
            }
        } else {
            data[name] = value;
        }
        this.setData(data, immediate);
    }

    /**
     * Remove value from storage
     */
    remove(name: string, immediate = false) {
        const data = this.getData();
        if (data[name] !== undefined) {
            delete data[name];
            this.setData(data, immediate);
        }
    }

    /**
     * Get value from storage
     */
    get(name: string | string[]): any | undefined {
        const hashData = this.getData();

        if (!hashData) {
            return undefined;
        }
        if (Array.isArray(name)) {
            return zipObject(
                name,
                (<string[]>name).map(n => hashData[n])
            );
        }

        return Object.prototype.hasOwnProperty.call(hashData, name) ? hashData[<string>name] : undefined;
    }

    ///////////////////////////
    ///
    /// Data manipulation
    ///
    ///////////////////////////

    /**
     * Retrieves all data in storage
     */
    protected abstract getData(): any;

    /**
     * Sets data to storage
     */
    protected abstract setData(data: any, immediate: boolean): void;
}
